import { useMutation, useQueryClient } from 'react-query';

import { addTechnicianToObject as update } from 'api/clients/addTechnicianToObject';

const useAddTechnicianToObject = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: AddTechnicianToObject,
    mutateAsync: AddTechnicianToObjectAsync,
    isLoading,
  } = useMutation(update, {
    onSuccess: _ => {
      // Ensure client/object views refresh after adding a technician
      queryClient.invalidateQueries(['clientsOnMap']);
    },
  });

  return {
    isSuccess,
    AddTechnicianToObject,
    AddTechnicianToObjectAsync,
    isLoading,
  };
};

export default useAddTechnicianToObject;
